import React from 'react';
import { connect } from 'react-redux';
import classes from './SubscriptionsView.scss';
import api from '../../../../utils/api';
import SubscriptionsTable from './SubscriptionsTable';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FlatButton from 'material-ui/FlatButton';
import MediaQuery from 'react-responsive';
import { push } from 'connected-react-router';
import { subscriptionSelector } from '../../../../routes/Subscriptions/selectors';

class SubscriptionsView extends React.Component {
    constructor(options) {
        super(options);
        this.state = {
            showAddDialog: false,
        };
    }

    componentDidMount = () => {
        this.props.fetchSubscriptions();
    };

    onSubmit = values => {};

    handleClose = () => {
        this.setState({
            showAddDialog: false,
        });
    };

    addSubscription = () => {
        this.props.push('/subscriptions/new');
    };

    confirmAddSubscription = values => {
        this.props.addSubscription({
            start_date: '2016-06-01',
            renewal: 'monthly',
            email: values.email,
        });
        this.setState({
            showAddDialog: false,
        });
    };

    submitForm = () => {
        this.refs.newSubscriptions.submit(); // will return a promise
    };

    render = () => {
        const style = {
            position: 'fixed',
            top: '20px',
            bottom: '20px',
        };

        const actions = [
            <FlatButton label="Abbrechen" primary onClick={this.handleClose} />,
            <FlatButton
                label="Lizenz hinzufügen"
                primary
                keyboardFocused
                onClick={this.submitForm}
            />,
        ];

        return (
            <div className={classes.container}>
                <MediaQuery query="(min-width: 830px)">
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '80px',
                            right: '40px',
                        }}>
                        <FloatingActionButton onMouseUp={this.addSubscription}>
                            <ContentAdd />
                        </FloatingActionButton>
                    </div>
                </MediaQuery>
                <h2>Software-Abo</h2>
                <SubscriptionsTable
                    subscriptions={this.props.subscriptions}
                    cancelSubscription={this.props.cancelSubscription}
                    uncoupleSubscriptions={this.props.uncoupleSubscriptions}
                />
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    subscriptions: subscriptionSelector(state),
});

const mapDispatchToProps = dispatch => ({
    push: payload => dispatch(push(payload)),
    fetchSubscriptions: () => dispatch(api.actions.subscriptions.fetchSubscriptions()),
    addSubscription: payload => dispatch(api.actions.subscriptions.addSubscription(payload)),
    cancelSubscription: payload => dispatch(api.actions.subscriptions.cancelSubscription(payload)),
    uncoupleSubscriptions: payload => {
        dispatch(api.actions.subscriptions.uncoupleSubscriptions({ ids: payload }));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubscriptionsView);
